// Initialiser les textareas avec fonctionnalités avancées
export function initTextareas(container = document) {
  // 1. Auto-resize des textareas
  const autoResizeTextareas = container.querySelectorAll('.textarea-field__textarea--auto-resize');
  
  autoResizeTextareas.forEach(textarea => {
    // Fonction pour ajuster la hauteur
    const adjustHeight = () => {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    };
    
    // Ajuster au chargement
    adjustHeight();
    
    // Ajuster à chaque saisie
    textarea.addEventListener('input', adjustHeight);
  });
  
  // 2. Compteur de caractères
  const textareasWithCounter = container.querySelectorAll('[data-max-length]');

  textareasWithCounter.forEach(textarea => {
    if (textarea.dataset.counterBound) return;
    textarea.dataset.counterBound = 'true';

    const maxLength = parseInt(textarea.getAttribute('data-max-length'));
    const field = textarea.closest('.textarea-field');
    let counter = field.querySelector('.textarea-field__counter');

    // Créer le compteur s'il n'existe pas
    if (!counter) {
      counter = document.createElement('span');
      counter.className = 'textarea-field__counter';
      field.appendChild(counter);
    }

    // Priorité : textarea.dsCountLength (lu à chaque calcul) > data-count="text" > value.length
    const measure = () => {
      const value = textarea.value;
      if (typeof textarea.dsCountLength === 'function') return textarea.dsCountLength(value);
      if (textarea.dataset.count === 'text') return visibleTextLength(value);
      return value.length;
    };

    const updateCounter = () => {
      const currentLength = measure();
      counter.textContent = `${currentLength} / ${maxLength}`;

      // Changer la couleur selon le seuil
      counter.classList.remove('textarea-field__counter--warning', 'textarea-field__counter--error');

      if (currentLength > maxLength) {
        counter.classList.add('textarea-field__counter--error');
      } else if (currentLength > maxLength * 0.9) {
        counter.classList.add('textarea-field__counter--warning');
      }
    };

    // Valeur remplie par code (brouillon…) : l'événement input n'est pas émis
    textarea.dsUpdateCounter = updateCounter;

    // Mettre à jour au chargement et à chaque saisie
    updateCounter();
    textarea.addEventListener('input', updateCounter);
  });

  // Optionnel : log pour debug
  // console.log('Textareas initialisés');
}

// Longueur du texte visible d'une valeur balisée : sans balises, entités décodées
// (&amp; = 1), sans préfixes de liste en début de ligne (« - », « 1. »).
// DOMParser n'exécute aucun script et ne charge aucune ressource ; <body> préserve les espaces de tête.
function visibleTextLength(value) {
  const { body } = new DOMParser().parseFromString(`<body>${value}`, 'text/html');
  body.querySelectorAll('script, style').forEach(el => el.remove());
  const text = body.textContent || '';
  return text.replace(/^[ \t]*(?:-|\d+\.)[ \t]+/gm, '').length;
}
